import { LastUpdated } from "../constants/Numbers";
import { Box, Typography, Link, IconButton, Tooltip } from "@mui/material";
import { useThemeMode } from "../contexts/ThemeModeContext";
import Logo from "../assets/JudoSV_logo.png";

export default function Footer() {
  const { darkMode, toggleTheme } = useThemeMode();

  return (
    <>
      <Box
        component="footer"
        sx={{
          mt: 6,
          py: 1.5,
          px: 2,
          backgroundColor: "#d50000", // même rouge que le header
          color: "white",
          textAlign: "center",
        }}
      >

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            component="img"
            src={Logo}
            alt="Logo Judo Club Sambreville"
            sx={{
              width: {
                xs: 32,
                md: 40,
              },
              mb: 1,
            }}
          />
          <Box>

            <Typography variant="body2" fontWeight="bold">
              Open International de Sambreville
            </Typography>

            <Typography variant="body2">
              JC Sambreville par{" "}
              <Link
                href="https://usidistrib.com"
                target="_blank"
                rel="noreferrer"
                underline="hover"
                color="inherit"
                fontWeight="bold"
              >
                Usidistrib </Link>{" "} © 2026
            </Typography>

            <Typography variant="caption" display="block" sx={{ mt: 1, opacity: 0.85, }}>
              Dernière mise à jour : {LastUpdated}
            </Typography>
          </Box>

          <Box
            sx={{
              position: "fixed",
              right: 16,
              bottom: 16,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Tooltip
              title={
                darkMode
                  ? "Basculer en mode clair"
                  : "Basculer en mode sombre"
              }
            >
              <IconButton onClick={toggleTheme}>
                {darkMode ? "🌙" : "🌞"}
              </IconButton>
            </Tooltip>
          </Box>

        </Box>
      </Box>
    </>
  );
}